"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.CloseIconSmall = CloseIconSmall;
exports.default = CloseIcon;
var _react = _interopRequireDefault(require("react"));
var _iconBase = _interopRequireDefault(require("./shared/icon-base"));
var _core = require("@emotion/core");
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function CloseIcon(props) {
  return (0, _core.jsx)(_iconBase.default, props, (0, _core.jsx)("path", {
    d: "M13.3995 11.9853L20.4706 19.0563L19.0563 20.4706L11.9853 13.3995L4.91423 20.4706L3.50001 19.0563L10.5711 11.9853L3.5 4.91421L4.91421 3.5L11.9853 10.5711L19.0564 3.5L20.4706 4.91421L13.3995 11.9853Z",
    fill: "currentColor"
  }));
}
function CloseIconSmall(props) {
  return (0, _core.jsx)(CloseIcon, _extends({
    size: "small"
  }, props));
}